import { each, isNil } from 'lodash';

export const combineString = (arr) => {
  let text = '';
  each(arr, (value) => {
    if (!isNil(value) && value !== '') text = text + ' ' + value;
  });

  return text.trim();
};
